import { Component, Inject } from '@angular/core';

import { MeasurementSystem } from '@core/enums/uom.enum';

import { TemplateDialogData } from '../models/template-dialog-data.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-transport1dialog',
  template: ` <mat-dialog-content>
    <h2>Transport 1 - Monthly Total Volumes per Mode including Emissions (Entry)</h2>
    @if (isUomSwitcherEnabled) {
      <app-uom-switcher
        [system]="system"
        (systemChange)="onSystemChange($event)">
      </app-uom-switcher>
    }
    <app-transport1
      [system]="system"
      [disabled]="disabled">
    </app-transport1>
  </mat-dialog-content>`,
  standalone: false,
})
export class Transport1DialogComponent {
  system: MeasurementSystem;
  isUomSwitcherEnabled: boolean;
  disabled: boolean;

  protected readonly MeasurementSystem: typeof MeasurementSystem = MeasurementSystem;

  constructor(@Inject(MAT_DIALOG_DATA) private data: TemplateDialogData) {
    this.system = data.system || MeasurementSystem.METRIC;
    this.isUomSwitcherEnabled = data.isUomSwitcherEnabled ?? false;
    this.disabled = data.disabled ?? true;
  }

  onSystemChange(system: MeasurementSystem): void {
    this.system = system;
  }
}
